module.exports = __webpack_public_path__ + "static/media/sa.6ea34317.svg";